export default {
  activity: {
    title: "Actividad",
    subtitle: "Registro de acciones de usuarios y administradores en la plataforma.",
    statEventsToday: "Eventos hoy",
    statLoginsToday: "Logins hoy",
    statActiveUsers: "Usuarios activos (7d)",
    statMostActiveOrg: "Org más activa (7d)",
    allOrgs: "Todas las orgs",
    fromPlaceholder: "Desde",
    toPlaceholder: "Hasta",
    clear: "Limpiar",
    eventsCount: "{n} eventos",
    loading: "Cargando…",
    emptyFilters: "Sin actividad registrada con los filtros actuales.",
    emptyYet: "Sin actividad registrada todavía.",
    colDateTime: "Fecha/Hora",
    colUser: "Usuario",
    colOrg: "Organización",
    colAction: "Acción",
    colDetail: "Detalle",
    colIp: "IP",
    systemOrg: "Haltrix / Sistema",
    resourceLabel: "Recurso:",
    fullDetailLabel: "Detalle completo:",
    prev: "← Anterior",
    next: "Siguiente →",
    pageOf: "Pág. {page} de {total}",
    // Grupos de filtro por acción
    grpAll: "Todas las acciones",
    grpAuth: "Autenticación",
    grpUsers: "Gestión usuarios",
    grpOrgs: "Organizaciones",
    grpImpersonate: "Impersonación",
    grpPortfolio: "Portfolio",
    grpCompetitors: "Competidores",
    grpAlerts: "Avisos",
    // Etiquetas de acción
    actLogin: "Login",
    actLoginFailed: "Acceso fallido",
    actSessionsRevoked: "Sesiones revocadas",
    actPasswordReset: "Reset contraseña",
    actImpersonate: "Impersonar",
    actUserCreated: "Usuario creado",
    actUserUpdated: "Usuario editado",
    actUserDeactivated: "Usuario desact.",
    actUserDeleted: "Usuario eliminado",
    actOrgCreated: "Org creada",
    actOrgUpdated: "Org editada",
    actLogoUploaded: "Logo subido",
    actProductAdded: "Producto añadido",
    actProductRemoved: "Producto eliminado",
    actCompetitorAdded: "Competidor añadido",
    actCompetitorRemoved: "Competidor eliminado",
    actAlertCreated: "Aviso creado",
    actAlertDeleted: "Aviso eliminado",
  },
};
